import { getDepartmentalPosition, supportedSystemPositions } from "@/Common/helpers/Positions";
const POSITIONS = supportedSystemPositions();

const getPositionInputDefinitions = (position) => {
	const departmental = getDepartmentalPosition(position);

	if (departmental === POSITIONS.SALES.SALES_ASSOCIATE) {
		return [
			{
				type: "Dollar",
				min: -50000,
				max: 50000,
				decimalsEditable: false,
				decimals: 2,
			},
			{
				type: "Dollar per Unit",
				min: -9999,
				max: 9999,
				decimalsEditable: false,
				decimals: 2,
			},
		];
	}

	return [
		{
			type: "Dollar",
			min: -50000,
			max: 50000,
			decimalsEditable: false,
			decimals: 2,
		},
		{
			type: "Percent",
			min: -100,
			max: 100,
			decimalsEditable: true,
			decimals: 2,
		},
		{
			type: "Dollar per Unit",
			min: -9999,
			max: 9999,
			decimalsEditable: false,
			decimals: 2,
		},
	];
};

const getPositionInputDelta = (position) => {
	const departmental = getDepartmentalPosition(position);
	if (departmental === POSITIONS.SALES.SALES_ASSOCIATE) {
		return 0.5;
	}
	return 1;
};

export { getPositionInputDefinitions, getPositionInputDelta };
